<template>
<div class="muji-review" :class="{ 'muji-review--none': isRenderNoneMessage || isGlobalError}" >
    <section class="muji-review__image" v-if="!isGlobalError && itemImages.length > 0" >
        <h2>ユーザー投稿画像</h2>
        <BaseReviewImageThumbsForWidget
          :sku-code="targetSku"
          :images="itemImages"
          :max-image-size="pageTopImageMaxSize" />
          <div v-if="itemImages" class="more-image-link"><a :href="reviewImageUrl" >投稿画像を一覧で見る</a></div>
    </section>
    <section class="muji-review__user">
        <h2>レビュー</h2>
        <BaseReviewRatingAverage
          :sku-code="linkTargetSku"
          :item-name="targetItem.sku_view_name"
          :count="itemAdditionalInfo.count"
          :average="itemAdditionalInfo.average" />
        <p v-if="isRenderNoneMessage && !isGlobalError" class="message__review-post--none"><b>商品の使い方やレビューの投稿をお待ちしております。</b><br>この商品を使用したことがある方は、最初のレビューを投稿してみませんか？</p>
        <p v-if="isGlobalError" class="message__review-post--none" >{{ globalErrorMessage }}</p>
    </section>
    <div>
      <CommonReviews
        :is-render-menu="false"
        :is-render-review-item="false"
        :default-sort-value="defaultSortValue"
        :default-refine-value="defaultRefineValue"
        :is-render-user-info="true"
        :is-render-review-more="false" />
    </div>
    <div class="muji-review__more" v-if="isReview" ><a :href="itemReviewUrl"><span class="num">{{ count }}</span>件すべてのレビューを見る</a></div>
    <div class="muji-review__post lsf-icon comments"><button v-on:click="linkPostPage">レビューを投稿する</button></div>
</div>
</template>

<script>
import BaseReviewRatingAverageSimple from '@/components/BaseReviewRatingAverageSimple'
import BaseReviewImageThumbsForWidget from '@/components/BaseReviewImageThumbsForWidget'
import BaseReviewRatingAverage from '@/components/BaseReviewRatingAverage'
import CommonReviews from '@/components/CommonReviews'
import { mapGetters, mapActions } from 'vuex'
import urls from '@/mixins/urls'
import loadings from '@/mixins/loadings'
import errors from '@/mixins/errors'
export default {
  name: 'ReviewWidget',
  mixins: [ urls, loadings, errors ],
  components: { CommonReviews, BaseReviewRatingAverageSimple, BaseReviewImageThumbsForWidget, BaseReviewRatingAverage },
  computed: {
    ...mapGetters({
      count: 'storeReviews/count',
      defaultSortValue: 'storeReviews/defaultSortValue',
      defaultRefineValue: 'storeReviews/defaultRefineValue',
      itemAdditionalInfo: 'storeReviews/itemAdditionalInfo',
      itemImages: 'storeReviews/itemImages',
      targetSku: 'storeReviews/targetSku',
      targetItem: 'storeReviews/targetItem',
      pageTopImageMaxSize: 'storeReviews/pageTopImageMaxSize',
      reviews: 'storeReviews/reviews',
      linkTargetSku: 'storeReviews/linkTargetSku'
    }),
    itemReviewUrl () {
      return this.getItemReviewUrl(this.linkTargetSku)
    },
    isReview () {
      return (this.reviews) && this.reviews.length > 0
    },
    reviewImageUrl () {
      return this.getReviewImageUrl(this.linkTargetSku)
    }
  },
  methods: {
    ...mapActions({
      getReviewsBySku: 'storeReviews/getReviewsBySku',
      getReviewsForAdditionalInfo: 'storeReviews/getReviewsForAdditionalInfo',
      getReviewImages: 'storeReviews/getReviewImages',
      getItems: 'storeReviews/getItems',
      setGlobalError: 'commons/setGlobalError',
      setLinkTargetSku: 'storeReviews/setLinkTargetSku'
    }),
    linkPostPage () {
      window.location.href = this.getReviewPostUrl(this.linkTargetSku, 'isDetail')
    }
  },
  created () {
    // 初期表示
    this.getItems().then(data => {
      if (this.isGlobalError) {
        return
      }
      if (this.isAuthenticationError) {
        this.setGlobalError({ message: '処理を継続するためにはログインが必要です。ログインしてください。' })
        return
      }
      Promise.all([
        this.getReviewImages(),
        this.getReviewsBySku()
      ]).then(() => {
        if (this.isAuthenticationError) {
          this.setGlobalError({ message: '処理を継続するためにはログインが必要です。ログインしてください。' })
        }
      })
    })
    const that = this
    window.$(document).on('sku-change', function (event, params) {
      that.setLinkTargetSku(params.skuCode)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ReviewWidget.vue